import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Checkbox } from '../../../../components/Checkbox';
import { Dropdown } from '../../../../components/Dropdown';
import { ManualDropdown } from '../../../../components/ManualDropdown';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { initiateNewCompnayValue, setNewCompanyValue, setNewCompanyAddress, deleteCompanyProperty } from '../../actions';
import { selectNewCompany, selectNewCompanyValue, selectCountries, selectCompany } from '../../selectors';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VBox } from '../../../../components/Box';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_COMPANY } from '../../constants';
import { getPropIdByName } from '../../../../utils/props';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {};

const MANUAL_DROPDOWN_OPTIONS = {
  prefence_incoming_transport: ['requires_transport', 'self_transport'],
  prefence_outgoing_transport: ['requires_transport', 'self_transport'],
};

const Container = styled.div`
  margin-bottom: 24px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
    .row-input {
      display: flex;
      flex-direction: row;
      .col-1 {
        flex-basis: 20%;
      }
      .col-2 {
        flex-basis: 75%;
      }
    }

      .dropdown-wrapper {
        > .Dropdown-root {
          width: 100px;
        }
      }
    }
  }
`;

const STATE = {
  addressLine1: '',
  postcode: '',
  city: '',
  countryId: null,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  get countries() {
    return this.props.countries;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  isCheckbox() {
    return ['release_before_incoming_transport', 'release_before_outgoing_transport'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return <FormField label={this.formFieldLabel()}>{children}</FormField>;
    }
  }

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));
    const value = options.find(o => o.value == this.props.value);
    return <Dropdown options={options} value={value} onChange={pair => this.props.setValue(pair.value)} />;
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'company'}
        key={this.props.type}
        type={this.props.type}
        editable={true}
        deletable={this.props.company && this.props.company[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value => {
          const propId = getPropIdByName(this.props.company, this.props.type);
          this.props.deleteProperty(propId, this.props.company.id, result => {
            if (result === true) {
              this.props.setValue('');
            }
          });
        }}
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  phoneNumber() {
    const fields = ['country_code', 'phone_number'];
    return (
      <VBox className="row-input">
        {fields.map((field, idx) => {
          return (
            <div key={field} className={`col-${idx + 1}`}>
              <Input
                type="number"
                value={this.props.values[field] || ''}
                onChange={evt => this.props.setValue(evt.target.value, field)}
              />
            </div>
          );
        })}
      </VBox>
    );
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.setAddress(this.state);
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.countries) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    if (this.isCheckbox()) {
      return (
        <Checkbox checked={this.props.value} onChange={() => this.props.setValue(!this.props.value)}>
          {this.lbl(`vehicle.property.${this.props.type}`)}
        </Checkbox>
      );
    }
  }
}

CompanyCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_COMPANY),
    value: selectNewCompanyValue(ownProps.type),
    values: selectNewCompany(),
    company: selectCompany(ownProps.company_id),
    countries: selectCountries(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewCompanyValue(name, value));
    },
    setAddress(address) {
      dispatch(setNewCompanyAddress(address));
    },
    deleteProperty(propertyId, companyId, callback) {
      dispatch(deleteCompanyProperty(propertyId, companyId, callback));
    },
    initiateValue() {
      dispatch(initiateNewCompnayValue(ownProps.type));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyCreateField = compose(
  withConnect,
  withRouter,
)(CompanyCreateFieldComp);
